import { render, staticRenderFns } from "./ApprovalCenter.vue?vue&type=template&id=86e4159c&scoped=true&"
import script from "./ApprovalCenter.vue?vue&type=script&lang=js&"
export * from "./ApprovalCenter.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCenter.vue?vue&type=style&index=0&id=86e4159c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e4159c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86e4159c')) {
      api.createRecord('86e4159c', component.options)
    } else {
      api.reload('86e4159c', component.options)
    }
    module.hot.accept("./ApprovalCenter.vue?vue&type=template&id=86e4159c&scoped=true&", function () {
      api.rerender('86e4159c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ApprovalCenter.vue"
export default component.exports